import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import './order-tracker.scss';

const OrderTracker = ({ orderNum, buttonWhite }) => {
  const [orderID, setOrderID] = useState('');
  const [orderTrackError, setOrderTrackError] = useState(false);
  const email = useSelector((state) => state.accounts.user.profile.email);

  const openNarvarPage = () => {
    const narvarURL =
      `https://purple.narvar.com/tracking/purple/purple?order_number=${
        orderID}`;
    window.open(narvarURL, '_blank');
  };

  const clearError = () => {
    const errorBox = document.querySelector('.global-error-box');
    if (!errorBox.classList.contains('d-none')) {
      errorBox.classList.add('d-none');
    }
  };

  const handleError = () => {
    const errorBox = document.querySelector('.global-error-box');
    errorBox.classList.remove('d-none');
  };

  useEffect(() => {
    async function fetchTracking() {
      const papiURL =
        `https://api.purple.com/api/v3/customer/order-tracking?id=${
          encodeURIComponent(orderNum)
        }&email=${
          email}`;
      let netsuiteID = '';
      await fetch(papiURL)
        .then((res) => res.json())
        .then((response) => {
          if (response[0].NETSUITE_ID && response[0].NETSUITE_ID !== '') {
            netsuiteID = response[0].NETSUITE_ID;
            setOrderID(netsuiteID);
          }
        })
        .catch(() => {
          setOrderTrackError(true);
        });
    }
    fetchTracking();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trackOrder = () => {
    clearError();
    if (!orderTrackError && orderID !== '') {
      openNarvarPage();
    } else {
      handleError();
    }
  };

  return (
    <div className="track-your-order">
      {orderID && (
        <button
          className={`track-btn button ${buttonWhite && 'white'}`}
          onClick={trackOrder}
          type="button"
          data-id="track-btn"
        >
          Track Order
        </button>
      )}
    </div>
  );
};

export default OrderTracker;
